var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pa-3"},_vm._l((_vm.templateItemData.list),function(item,idx){return _c('div',{key:'listItem' + idx,staticClass:"display--grid"},[_c('Text4ListItem',{attrs:{"template-item-data":item}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }